import { Mappeable } from './mappeable.model';

export class JobOS extends Mappeable {
    jobId: number;
    organizationalStructure: any;
}